var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 4px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.57,37.86c-.35-.43-.89-.65-1.44-.6-.55.05-1.04.38-1.3.86l-18.73,34.64c-.34.62-.24,1.39.24,1.91.32.35.77.54,1.22.54.22,0,.45-.04.66-.14l34.72-15.12c.48-.21.83-.63.95-1.13.12-.51,0-1.04-.33-1.44l-15.99-19.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.09,49.13c-.84.38-1.2,1.36-.83,2.2.38.84,1.36,1.21,2.2.83,3.22-1.45,7.08-1.51,10.33-.14.42.18.87.17,1.26.01s.73-.47.92-.9c.36-.85-.04-1.82-.88-2.17-4.09-1.73-8.94-1.67-13,.17h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.16,27.47c-.04-.92-.82-1.62-1.73-1.58-.92.04-1.63.82-1.58,1.73.16,3.53-1.22,7.14-3.7,9.65-.32.32-.48.74-.48,1.17s.17.86.49,1.18c.65.64,1.7.64,2.35-.02,3.12-3.16,4.86-7.69,4.65-12.14h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.61,33h3.23c.92,0,1.66.92,1.66,1.66v3.23c0,.92-.74,1.66-1.66,1.66h-3.23c-.92,0-1.66-.92-1.66-1.66v-3.23c0-.92.74-1.66,1.66-1.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.76,30.24c1.5,0,2.72-1.22,2.72-2.72s-1.22-2.72-2.72-2.72-2.72,1.22-2.72,2.72,1.22,2.72,2.72,2.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeEvent);
export default __webpack_public_path__ + "static/media/acae_event.456d596e.svg";
export { ForwardRef as ReactComponent };